// src/components/ErrorBoundary.jsx
import React from "react";
export default class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };
  static getDerivedStateFromError(error) { return { hasError: true, error }; }
  componentDidCatch(error, info) { console.error("[boom] ErrorBoundary:", error, info); }
  render() {
    if (this.state.hasError) {
      return <div style={{padding:16}}>
        <h2>Une erreur est survenue</h2>
        <pre style={{whiteSpace:"pre-wrap"}}>{String(this.state.error)}</pre>
      </div>;
    }
    return this.props.children;
  }
}
